import { notify } from "@/shared/utils/notify";
import { useNavigate } from "react-router-dom";

import {
  deleteCMS,
  refreshTableCMS,
  setIsCMSForUpdate,
} from "../../../redux";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useCMS } from "./useCMS";
import { DataCMS } from "../../../redux/@types/cms";

export const useTableCMS = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { tableProps } = useCMS();

  const changeCMSForUpdate = async (val: DataCMS) => {
    dispatch(setIsCMSForUpdate(true));
    navigate(`/cms/${val.id}`);
  };

  const removeCMS = async (valId: number) => {
    try {
      await deleteCMS(valId);
      dispatch(refreshTableCMS(true));
      notify.success(`Se ha borrado con éxito el CMS con id:${valId}`);
      tableProps?.refresh();
    } catch (err: any) {
      console.log({ err });
      notify.error(err?.message || "No se pudo eliminar el contenido");
    }
  };

  /** @deprecated Prefer removeCMS + Popconfirm en la tabla */
  const showDeleteConfirm = (valId: number, _val: string) => {
    void removeCMS(valId);
  };

  return {
    changeCMSForUpdate,
    showDeleteConfirm,
    removeCMS,
  };
};
